import React from "react";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import styles from "./DragIndicatorStyles.module.css";
import classnames from "classnames";

export const DragIndicator = ({ disabled, iconWrapperStyle }) => {
  return (
    <div
      className={classnames(
        styles.iconWrapper,
        iconWrapperStyle,
        disabled && styles.disabled
      )}
    >
      <DragIndicatorIcon className={styles.icon} />
    </div>
  );
};
